<!--
 * @Description: 
 * @Date: 2025-06-22 11:08:41
 * @LastEditors: function
 * @LastEditTime: 2025-06-23 16:37:48
 * @FilePath: \protal-web\src\components\navTitle\index.vue
-->
<template>
  <div class="disf disfac disfjc p1 zindex">
    <img src="@/assets/images/left.png"  width="88px" height="32px"  alt="">
    <span class="title" :style="{color: textColor}">{{ title }}</span>
    <img src="@/assets/images/right.png" width="88px" height="32px" alt="">
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      default: '首页'
    },
    textColor: {
      type: String,
      default: '#000000'
    }
  }
}
</script>


<style scoped lang="less">
.title{
  font-size: 32px;
  color: #000000;
  font-weight: 600;
  margin: 0 20px;
}
.zindex{
  z-index: 6;
}
</style>